// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3TUFu","productName":"Table_productName__X0oKe"};